export default __webpack_public_path__ + "adfb713ccce49e72e31328e3971f2c74.png";